<div class="detail-page">
  <app-asiakas-otsikko otsikko="Asetukset, asiakastiedot" paluuUrl="/asiakkaat" [asiakas]="asiakas"></app-asiakas-otsikko>

  @if (kirjanpitajaOnDevaajaObservable | async) {
    <div style="padding-bottom: 20px">
      <h3 style="margin: 0">Urit</h3>
      <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
        Asiakas: <a [href]="asiakasEncodedUriObservable | async" target="_BLANK">{{ asiakasUriObservable | async }}</a>
      </div>
    </div>
  }

  <!-- Disable Google Sheets component for the time being: https://lemontree-squad.monday.com/boards/6845117610/pulses/9744921538 -->
  @if (false) {
    <div style="display: flex; gap: 0.25rem; flex-direction: column; width: fit-content">
      <a mat-button [href]="asiakas.sheetLink" target="_blank" [disabled]="!asiakas.sheetLink" [style.pointer-events]="asiakas.sheetLink ? 'auto' : 'none'" [attr.aria-disabled]="asiakas.sheetLink ? null : 'true'">
        <mat-icon>open_in_new</mat-icon>
        Asiakkaan lisätiedot (Google Sheets)
      </a>
      <button mat-button (click)="muokkaaGoogleSheetLinkkia()" style="font-size: 12px; width: fit-content; min-height: auto; padding: 4px" class="gray-text">Muokkaa linkkiä</button>
    </div>
  }

  <form (ngSubmit)="save()" novalidate>
    <div class="cont">
      <div style="max-width: 450px">
        <div class="light-blue-text otsikko">Yhteystiedot</div>
        <mat-form-field>
          <mat-label>{{ 'asiakas.nimi' | translate | async }}</mat-label>
          <input #nimiInput type="text" [formField]="lomake.nimi" matInput />
          @if (naytetaankoVirhe(lomake.nimi, 'required')) {
            <mat-error> Nimi puuttuu </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Y-tunnus</mat-label>
          <input type="text" autocomplete="kirjanpitoaineistoarkki" [formField]="lomake.ytunnus" matInput data-lpignore="true" />
          @if (ytunnusVirhe()) {
            <mat-hint><span class="lemon-error">Y-tunnus on virheellinen. Tämä ei estä tallentamista. Tarkista Y-tunnus</span></mat-hint>
          }
          @if (naytetaankoVirhe(lomake.ytunnus, 'required')) {
            <mat-error> Y-tunnus puuttuu </mat-error>
          }
          @if (naytetaankoVirhe(lomake.ytunnus, 'tupla')) {
            <mat-error> Y-tunnus on jo käytössä yrityksellä {{ ytunnuksenTupla()?.nimi }}. </mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ 'lasku.katuosoite' | translate | async }}</mat-label>
          <input type="text" autocomplete="kirjanpitoaineistoarkki" [formField]="lomake.katuosoite" matInput data-lpignore="true" />
          <!-- <mat-error *ngIf="katuosoite?.errors?.required && (katuosoite?.dirty || katuosoite?.touched)">
          {{ 'lasku.validation.katuosoite.required' | translate | async }}
        </mat-error> -->
        </mat-form-field>

        <div>
          <mat-form-field style="width: 48%; float: left">
            <mat-label>{{ 'lasku.postinro' | translate | async }}</mat-label>
            <input type="text" autocomplete="kirjanpitoaineistoarkki" [formField]="lomake.postinro" matInput data-lpignore="true" />
            @if (naytetaankoVirhe(lomake.postinro, 'required')) {
              <mat-error>
                {{ 'lasku.validation.postinro.required' | translate | async }}
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field style="width: 48%; float: right">
            <mat-label>{{ 'lasku.postitoimipaikka' | translate | async }}</mat-label>
            <input type="text" autocomplete="kirjanpitoaineistoarkki" [formField]="lomake.postitoimipaikka" matInput data-lpignore="true" />
            @if (naytetaankoVirhe(lomake.postitoimipaikka, 'required')) {
              <mat-error>
                {{ 'lasku.validation.postitoimipaikka.required' | translate | async }}
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div style="clear: both; display: block"></div>

        <mat-form-field>
          <mat-label>{{ 'lasku.maa' | translate | async }}</mat-label>
          <mat-select [formField]="lomake.maa" style="width: 100%">
            @for (maa of suodatetutMaat | async; track maa) {
              <mat-option [value]="maa.koodi">
                {{ maa.nimi }}
              </mat-option>
            }
          </mat-select>
          @if (naytetaankoVirhe(lomake.maa, 'required')) {
            <mat-error>
              {{ 'lasku.validation.maa.required' | translate | async }}
            </mat-error>
          }
        </mat-form-field>

        <!-- <mat-form-field *ngIf="naytaAdmin">
      <mat-label>{{ 'Vastuukirjanpitäjä' }}</mat-label>
      <mat-select  formControlName="kasittelija">
        <mat-option *ngFor="let kirjanpitaja of kirjanpitajat" [value]="kirjanpitaja.avain">
          {{kirjanpitaja.etunimi}} {{ kirjanpitaja.sukunimi }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="naytaAdmin">
      <mat-label>{{ 'Väliaikainen tuuraaja' }}</mat-label>
      <mat-select  formControlName="kasittelijavara">
        <mat-option [value]="null">
          Ei tuuraajaa
        </mat-option>
        <mat-option *ngFor="let kirjanpitaja of kirjanpitajat" [value]="kirjanpitaja.avain">
          {{kirjanpitaja.etunimi}} {{ kirjanpitaja.sukunimi }}
        </mat-option>
      </mat-select>
    </mat-form-field> -->
      </div>

      <div app-asiakas-ytj-tiedot></div>

      <!-- <div style="width: 100%;">
  <div class="light-blue-text otsikko">YTJ-tiedot</div>
  <div class="ytj-data" *ngIf="ytjHtmlObservable | async; as ytjHtml; else ytjLadataan" [innerHtml]="ytjHtml"></div>
  <ng-template #ytjLadataan>
    Ladataan ...
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </ng-template>
</div> -->
    </div>

    <div style="max-width: 450px">
      <div class="light-blue-text otsikko">Pääsääntöinen asiointikieli</div>

      <p>Pääsääntöisen asiointikielen mukaan valitaan asiakkaalle lähtevien kirjanpito- ja laskutussähköpostien ja niiden liitetiedostojen kieli.</p>

      <div style="max-width: 450px">
        <mat-radio-group [formField]="lomake.laskunKieli" aria-label="Valitse">
          <mat-radio-button [value]="'fi'">Suomi</mat-radio-button>
          <mat-radio-button [value]="'en'">Englanti</mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="light-blue-text otsikko">Muut tiedot</div>
      <div>
        <mat-checkbox [formField]="lomake.ossRekisterissa">Asiakas on rekisteröitynyt arvonlisäveron erityisjärjestelmään</mat-checkbox>
      </div>
      <div>
        <mat-checkbox [formField]="lomake.estaAlvKasittely">Käsittele palkkaus.fi automaattikirjaukset alvittomina</mat-checkbox>
      </div>
      @if (isAdminObservable | async) {
        <div>
          <mat-checkbox [formField]="lomake.testiasiakas">Asiakas on testiasiakas</mat-checkbox>
        </div>
      }
      <div>
        <mat-checkbox [formField]="lomake.tilinpaatosRekisteroidaanBruttotuloslaskelmalla">Asiakkaan tilinpäätös rekisteröidään bruttotuloslaskelmalla</mat-checkbox>
      </div>
      @if (!!lomake.saleDoneBy().value()) {
        <mat-form-field style="margin-top: 15px">
          <mat-label>Myyjä</mat-label>
          <input matInput [formField]="lomake.saleDoneBy" />
        </mat-form-field>
      }
    </div>

    <div style="max-width: 450px">
      <div class="light-blue-text otsikko">Tagit</div>
      <app-asiakas-tagit [asiakas]="asiakas"></app-asiakas-tagit>
    </div>

    <div class="light-blue-text otsikko">Lisäpalvelut</div>
    <div class="alaotsikko">Kirjanpito</div>
    <div class="left-margin">
      <div>
        <mat-checkbox [checked]="sopimuksenLisapalvelutMap()?.[SopimusLisapalvelu.PALKAT]" [disabled]="true">
          <span>Palkkapalvelu</span>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="lisapalv-icon" style="width: 1em; height: 1em; vertical-align: middle; fill: none; stroke: currentColor; stroke-linejoin: round; stroke-width: 32px">
            <rect x="48" y="144" width="416" height="288" rx="48" ry="48" />
            <path d="M411.36,144V114A50,50,0,0,0,352,64.9L88.64,109.85A50,50,0,0,0,48,159v49" />
            <path d="M368,320a32,32,0,1,1,32-32A32,32,0,0,1,368,320Z" style="fill: currentColor" />
          </svg>
        </mat-checkbox>
      </div>

      <div>
        <mat-checkbox [checked]="sopimuksenLisapalvelutMap()?.[SopimusLisapalvelu.ENNAKKOVEROJEN_SEURANTA]" [disabled]="true">
          <span>Ennakkoverojen seuranta</span>
          <i class="lisapalv-icon icon ion-ios-pizza-outline"></i>
        </mat-checkbox>
      </div>
    </div>

    @if (asiakkaanApixTiedotObservable | async; as asiakkaanApixTiedot) {
      <div class="alaotsikko">Lemonaid</div>
      <div class="left-margin">
        <div>
          <mat-checkbox [checked]="asiakkaanApixTiedot.paymentReceiveIsActive" [disabled]="true"> <span>Laskujen vastaanotto</span> <i class="lisapalv-icon icon ion-ios-flash-outline" style="font-size: 28px"></i> </mat-checkbox>
        </div>
        <div>
          <mat-checkbox [checked]="asiakkaanApixTiedot.paymentIsActive" [disabled]="true"> <span>Laskujen maksaminen</span> <i class="lisapalv-icon icon ion-ios-flash"></i> </mat-checkbox>
        </div>
        <div>
          <mat-checkbox [checked]="laskureskontraVoimassa()" [disabled]="true">Laskukohtainen automaattireskontra </mat-checkbox>
        </div>
      </div>
    }

    <div>
      <div style="max-width: 450px">
        <div class="light-blue-text otsikko">Kuvaus toiminnasta ja tilanteesta</div>
        <mat-form-field>
          <mat-label>Kuvaus</mat-label>
          <textarea matInput [formField]="lomake.kuvausKuvaus" cdkTextareaAutosize></textarea>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Aloitusajankohta</mat-label>
          <textarea matInput [formField]="lomake.kuvausAloitus" cdkTextareaAutosize></textarea>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Huomioita</mat-label>
          <textarea class="purple-text" matInput [formField]="lomake.kuvausHuomioita" cdkTextareaAutosize></textarea>
        </mat-form-field>
      </div>
      <div style="max-width: 200px">
        <div class="light-blue-text otsikko">Aloituspalaveri</div>
        <mat-checkbox [formField]="lomake.palaveriOnkoPidetty">Aloituspalaveri pidetty</mat-checkbox>
        <div style="font-size: 12.5px; margin: 1em">
          @if (naytetaankoVirhe(lomake.palaveriTyyppi, 'required')) {
            <mat-error class="mat-form-field-invalid">Palaverin tyyppi puuttuu.</mat-error>
          }
          <div>Palaverin tyyppi:</div>
          <mat-radio-group [formField]="lomake.palaveriTyyppi" aria-label="Valitse">
            <mat-radio-button [value]="'puhelin'">Puhelin</mat-radio-button>
            <mat-radio-button [value]="'Google Meet'">Etäpalaveri</mat-radio-button>
            <mat-radio-button [value]="'toimisto'">Toimisto</mat-radio-button>
          </mat-radio-group>
        </div>
        <mat-form-field style="margin: 1em">
          <mat-label>Palaverin ajankohta</mat-label>
          <input matInput [formField]="lomake.palaveriPvm" [matDatepicker]="palaveriDatePicker" />
          <mat-datepicker-toggle matSuffix [for]="palaveriDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #palaveriDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <div>
      <div class="light-blue-text otsikko">Arvio tositteiden määrästä</div>
      <div class="cont">
        <mat-form-field>
          <mat-label>Ostolaskut/kuitit</mat-label>
          <input decimalNumberField matInput [numberOfDecimals]="0" [formField]="lomake.tositemaaratKuitit" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Myyntilaskut</mat-label>
          <input decimalNumberField matInput [numberOfDecimals]="0" [formField]="lomake.tositemaaratMyyntilaskut" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Myyntiraportit</mat-label>
          <input decimalNumberField matInput [numberOfDecimals]="0" [formField]="lomake.tositemaaratMyyntiraportit" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Palkkalaskelmat</mat-label>
          <input decimalNumberField matInput [numberOfDecimals]="0" [formField]="lomake.tositemaaratPalkkalaskelmat" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Muuta</mat-label>
          <textarea matInput [formField]="lomake.tositemaaratMuuta" cdkTextareaAutosize></textarea>
        </mat-form-field>
      </div>
    </div>

    <div>
      <div class="light-blue-text otsikko">Maksutavat</div>
      <div class="cont" style="justify-content: space-between">
        <div>
          <mat-checkbox [formField]="lomake.maksutavatLasku">Lasku</mat-checkbox>
        </div>
        <div>
          <mat-checkbox [formField]="lomake.maksutavatKorttipaate">Korttipääte</mat-checkbox>
          <mat-form-field>
            <mat-label>Mikä?</mat-label>
            <textarea matInput [formField]="lomake.maksutavatKorttipaateLisa" cdkTextareaAutosize></textarea>
          </mat-form-field>
        </div>
        <div>
          <mat-checkbox [formField]="lomake.maksutavatVerkkokauppa">Verkkokauppa</mat-checkbox>
          <mat-form-field>
            <mat-label>Maksutavat</mat-label>
            <textarea matInput [formField]="lomake.maksutavatVerkkokauppaMaksutavat" cdkTextareaAutosize></textarea>
          </mat-form-field>
        </div>
        <div>
          <mat-checkbox [formField]="lomake.maksutavatKateinen">Käteinen</mat-checkbox>
        </div>
        <div>
          <mat-checkbox [formField]="lomake.maksutavatTilitykset">Tilitykset</mat-checkbox>
          <mat-form-field>
            <mat-label>Mitä?</mat-label>
            <textarea matInput [formField]="lomake.maksutavatTilityksetMita" cdkTextareaAutosize></textarea>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div style="max-width: 600px">
      <div class="light-blue-text otsikko">Pankkitiedot</div>
      <div class="cont">
        <mat-form-field>
          <mat-label>Yrityksen pankki</mat-label>
          <textarea matInput [formField]="lomake.pankkiPankki" cdkTextareaAutosize></textarea>
        </mat-form-field>
        <div>
          <mat-checkbox [formField]="lomake.pankkiYhteys">Pankkiyhteys</mat-checkbox>
        </div>
        <div>
          <mat-checkbox [formField]="lomake.pankkiEiTilia">Ei pankkitiliä kirjanpidossa</mat-checkbox>
        </div>
      </div>
    </div>

    <div style="max-width: 650px">
      <div class="light-blue-text otsikko">Auto</div>
      <div class="cont">
        <div>
          <mat-checkbox [formField]="lomake.auto">Yrityksen toimintaan käytetään autoa</mat-checkbox>
          <div class="cont" style="padding-top: 10px">
            <mat-radio-group [formField]="lomake.autoTyyppi" aria-label="Valitse">
              <mat-radio-button [value]="'henkilo'">Henkilöauto</mat-radio-button>
              <mat-radio-button [value]="'paketti'">Pakettiauto</mat-radio-button>
            </mat-radio-group>
            <mat-radio-group [formField]="lomake.autoAjo" aria-label="Valitse">
              <mat-radio-button [value]="'enemmanyksityis'">Enemmän yksityisajoa</mat-radio-button>
              <mat-radio-button [value]="'enemmantyo'">Enemmän työajoa</mat-radio-button>
              <mat-radio-button [value]="'kokonaantyo'">100% työajoa</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <mat-form-field>
          <mat-label>Lisätietoja</mat-label>
          <textarea matInput [formField]="lomake.autoLisa" cdkTextareaAutosize></textarea>
        </mat-form-field>
      </div>
    </div>

    <div style="max-width: 450px">
      <div class="light-blue-text otsikko">Sijoitustoiminta</div>
      <div class="cont">
        <div>
          <mat-checkbox [formField]="lomake.sijoitus">Yrityksellä on sijoitustoimintaa</mat-checkbox>
        </div>
        <mat-form-field>
          <mat-label>Mitä?</mat-label>
          <textarea matInput [formField]="lomake.sijoitusLisa" cdkTextareaAutosize></textarea>
        </mat-form-field>
      </div>
    </div>

    <div style="max-width: 450px">
      <div class="light-blue-text otsikko">Ohjelmisto</div>
      <div class="cont">
        <mat-radio-group [formField]="lomake.ohjelmisto" aria-label="Valitse">
          <mat-radio-button value="1">Lemonaid</mat-radio-button>
          <mat-radio-button value="2">Holvi</mat-radio-button>
          <mat-radio-button value="3">Molemmat</mat-radio-button>
        </mat-radio-group>
        <mat-form-field>
          <mat-label>Lisätietoja</mat-label>
          <textarea matInput [formField]="lomake.ohjelmistoLisa" cdkTextareaAutosize></textarea>
        </mat-form-field>
      </div>
    </div>

    <div style="max-width: 450px">
      <div class="light-blue-text otsikko">Palkat</div>
      <div class="cont">
        <mat-form-field>
          <mat-label>Tiedot</mat-label>
          <textarea matInput [formField]="lomake.palkatLisa" cdkTextareaAutosize></textarea>
          <mat-hint>Onko työntekijöitä? Miten palkanlaskenta hoidetaan?</mat-hint>
        </mat-form-field>
      </div>
    </div>

    <!-- <div style="max-width: 450px;">
<div class="light-blue-text otsikko">Riskiarvio</div>
<div class="cont">
  <mat-radio-group formControlName="riskiarvio" aria-label="Valitse">
    <mat-radio-button value="'vahainen'">Vähäinen riski</mat-radio-button>
    <mat-radio-button value="'kohonnut'">Kohonnut riski</mat-radio-button>
    <mat-radio-button value="'korkea'">Korkea riski</mat-radio-button>
  </mat-radio-group>
  <mat-form-field>
    <textarea matInput formControlName="riskiarvioLisa" cdkTextareaAutosize placeholder="Lisätietoja"></textarea>
  </mat-form-field>
</div>
</div> -->

    <div style="display: flex; justify-content: space-evenly; padding-top: 40px; padding-bottom: 2em">
      <!-- <button class="secondarybutton" mat-button routerLink="/asiakkaat" type="button">{{'yleiset.peruuta' | translate | async}}</button> -->
      <app-primary-button (click)="save()" actionId="Tallenna asiakastiedot" [actionContext]="[lomake().value()]">{{ 'yleiset.tallenna' | translate | async }}</app-primary-button>
    </div>
  </form>
</div>
